import { Link } from "gatsby"
import { gsap } from "gsap"
import React, { useEffect, useState } from "react"
import "./navbar.scss"
import Logo from "./sd-logo.svg"
import { useLocation } from "@reach/router"

function SideBar() {
    const { pathname } = useLocation()
    const col1ItemsArr = [
        {
            id: 0,
            link: "https://www.linkedin.com/company/saigon-digital/",
            text: "LinkedIn",
            gaAction: "linkedin_click",
            col: 1
        },
        {
            id: 1,
            link: "https://www.facebook.com/saigondigital2021",
            text: "Facebook",
            gaAction: "facebook_click",
            col: 1
        },
        {
            id: 2,
            link: "https://www.instagram.com/saigon.digital/",
            text: "Instagram",
            gaAction: "instagram_click",
            col: 1
        },
        {
            id: 3,
            link: "https://github.com/Saigon-Digital",
            text: "Github",
            gaAction: "github_click",
            col: 1
        },
        {
            id: 4,
            link: "https://www.youtube.com/@saigon.digital",
            text: "Youtube",
            gaAction: "youtube_click",
            col: 1
        }
    ]
    const col2ItemsArr = [
        {
            id: 0,
            link: "/about",
            text: "About",
            col: 2
        },
        {
            id: 1,
            link: "/services",
            text: "Services",
            col: 2
        },
        {
            id: 2,
            link: "/case-studies",
            text: "Case Studies",
            col: 2
        },
        {
            id: 3,
            link: "/blog/",
            text: "Blog",
            col: 2
        },
        {
            id: 4,
            link: "/resources/",
            text: "Resources",
            col: 2
        },
        {
            id: 5,
            link: "/contact",
            text: "Contact",
            col: 2
        }
    ]
    const [isOpen, setIsOpen] = useState(true)
    const [menuTl] = useState(gsap.timeline({ paused: true }))
    useEffect(() => {
        menuTl
            .to(
                ".sidebar",
                {
                    width: "100%",
                    ease: "ease.out"
                },
                0.2
            )
            .to(".navigation-bg", {
                width: "0%",
                duration: 0.3
            })
            .to(".right-content", {
                top: 0,
                opacity: 1,
                duration: 0.3
            })
            .to(".icon", {
                top: 0,
                opacity: 1,
                ease: "bounce.out"
            })
            .to(".menu-btn", {
                className: "menu-btn is-active",
                duration: 0
            })
            .reverse()
    }, [])

    useEffect(() => {
        const close = e => {
            if (e.keyCode === 27) {
                toggleMenuTimeline()
            }
        }
        window.addEventListener("keydown", close)
        return () => window.removeEventListener("keydown", close)
    }, [])

    useEffect(() => {
        setIsOpen(false)
    }, [pathname])

    const toggleMenuTimeline = () => {
        menuTl.reversed(!menuTl.reversed())
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = "unset"
        }
    }, [isOpen])
    return (
        <div
            className="sidebar h-screen overflow-hidden bg-clip-padding"
            id="menu-toggle"
        >
            <button
                className={"menu-btn"}
                onClick={toggleMenuTimeline}
                aria-label="menu button"
                id="nav-btn"
            >
                <span className="btn-line my-1 mx-auto h-[2px] w-5 md:my-[7px] md:w-6"></span>
                <span className="btn-line my-1 mx-auto h-[2px] w-5 md:my-[7px] md:w-6"></span>
            </button>

            <div className="navigation-bg one"></div>
            <div className="menu-grid absolute z-10 grid h-full w-full lg:grid-cols-2">
                <div className="hidden h-full justify-center bg-[#eaf0fe] bg-no-repeat pt-[71px] pb-20 lg:grid">
                    <div className="flex h-full w-full flex-col justify-between">
                        <div>
                            <Link
                                className={`menu-logo aspect-[127/43] w-[127px] md:w-[214px]`}
                                to="/"
                                aria-label="Go to homepage"
                            >
                                <img
                                    alt="logo"
                                    src={Logo}
                                    className="h-full w-full"
                                />
                            </Link>
                        </div>
                        <div>
                            <h2 className="idea-text idea-text-1 inline-block pb-6 font-['Poppins'] text-[56px] font-bold leading-[56px] lg:max-w-sm xl:max-w-none">
                                Have an idea? <span className="icon">💡</span>
                            </h2>
                            <h2 className="idea-text idea-text-2 font-['Poppins'] text-[40px] leading-[40px]">
                                Tell us about it...
                            </h2>
                        </div>
                        <div>
                            <div className="pb-10 text-2xl text-[#6B6A6A]">
                                <div>
                                    <a
                                        href="mailto:hello@saigon.digital"
                                        className="leading-[38px]"
                                    >
                                        hello@saigon.digital
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="tel:+84332364293"
                                        className="leading-8"
                                    >
                                        <strong>+84332364293</strong>
                                    </a>
                                </div>
                            </div>
                            <div>
                                <p className="font-['Work_Sans'] text-base leading-8 text-[#717171]">
                                    19 To Huu, Thu Thiem Ward, Thu Duc City, Ho
                                    Chi Minh City, Vietnam
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="2xl:px-28 h-full w-full bg-white pl-10 lg:px-16 xl:px-20">
                    <div className="right-content grid h-full items-center">
                        <div className="grid md:grid-cols-[0.8fr_1.2fr]">
                            <div className="menu-col-left hidden md:block">
                                <div className="menu-title text-grey-small mb-5">
                                    Social
                                </div>
                                <div className="menu-item flex flex-col gap-y-6">
                                    {col1ItemsArr.map(item => {
                                        return (
                                            <a
                                                onClick={() => {
                                                    window.dataLayer.push({
                                                        event: item.gaAction,
                                                        eventCategory:
                                                            "button_onclick"
                                                    })
                                                }}
                                                href={item.link}
                                                target="_blank"
                                                key={item.id}
                                                className="sidebar__item menu-item-nav w-fit text-base leading-loose md:text-lg"
                                            >
                                                {item.text}
                                            </a>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="menu-col-right">
                                <p className="menu-title text-grey-small mb-7">
                                    Menu
                                </p>
                                <nav
                                    aria-label="Main Navigation"
                                    className="flex flex-col items-start gap-y-2 md:gap-y-4"
                                >
                                    <ul>
                                        {col2ItemsArr.map(item => {
                                            return (
                                                <li className="mb-2">
                                                    <Link
                                                        to={item.link}
                                                        key={item.id}
                                                        className={`sidebar__item menu-item-nav text-3xl md:text-4xl ${
                                                            item.link ===
                                                            pathname
                                                                ? "active text-primary-color"
                                                                : ""
                                                        }`}
                                                    >
                                                        {item.text}
                                                    </Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </nav>
                            </div>
                            <div className="mt-10 grid lg:hidden">
                                <p className="text-grey-small pb-4">
                                    Get in touch
                                </p>
                                <a
                                    href="mailto:hello@saigon.digital"
                                    className="leading-[38px]"
                                >
                                    hello@saigon.digital
                                </a>
                                <a
                                    href="tel:+84332364293"
                                    className="leading-8"
                                >
                                    +84332364293
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SideBar
